export default "__VITE_ASSET__DadlDYI6__"